import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { commonActions } from "./reducers/common";
import { authClear } from "./service/util/authClear";
import store from 'reducers/store';
import axios from "axios";

const root = document.getElementById('root');

if (localStorage.accessToken !== undefined) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.accessToken}`;
    store.dispatch(commonActions.setToken(localStorage.accessToken));
}
if (localStorage.user === undefined) {
    store.dispatch(commonActions.setLogout());
    authClear();
}
if (localStorage.user) {
    store.dispatch(commonActions.setUser(JSON.parse(localStorage.user)));
}
window.onload = () => {
    render();
};

function render() {
    ReactDOM.createRoot(root).render(
        <Provider store={store}>
            <Router>
                <App />
            </Router>
        </Provider>
    )
}
